// Documentation: https://lingui.dev/tutorials/setup-vite
import { i18n } from "@lingui/core";
import { detect, fromNavigator } from "@lingui/detect-locale";

var supportedLangs =['ko', 'ja', 'en'];

export async function activateLanguage(locale: string) {
  if(!supportedLangs.includes(locale)) {
    locale = 'en';
  }
  const { messages } = await import(`./${locale}/messages.po`);
  i18n.load(locale, messages)
  i18n.activate(locale)
  // lang 속성은 :lang 기반 폰트 스위칭(ja)·접근성에 쓰이므로 언어 전환 경로 어디서든 함께 갱신
  document.documentElement.setAttribute("lang", locale);
  localStorage.setItem('app-lang', locale);
}

export var defaultLanguage = 'en';

export async function initateLingui() {
  // navigator.languages[0]이 시스템 첫 번째 언어를 정확히 반환
  // fromNavigator()는 WebView에서 ko를 반환하는 버그가 있을 수 있음
  const rawLang = (navigator.languages && navigator.languages[0]) || detect(fromNavigator(), () => 'en') || 'en';
  defaultLanguage = rawLang.substring(0, 2);
  await activateLanguage(defaultLanguage);
}
